import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

const inputClassName = "w-full px-3 py-2 pe-11 rounded-md border border-border bg-card focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none text-sm";

export function SecretInput({ testid, value, onChange, placeholder, hasSavedValue = false, onRevealSaved, inputRef }) {
    const [visible, setVisible] = useState(false);
    const [revealing, setRevealing] = useState(false);

    const toggleVisibility = async () => {
        if (visible) {
            setVisible(false);
            return;
        }
        if (!value && hasSavedValue && onRevealSaved) {
            setRevealing(true);
            try {
                await onRevealSaved();
                setVisible(true);
            } finally {
                setRevealing(false);
            }
            return;
        }
        setVisible(true);
    };

    return (
        <div className="relative">
            <input
                ref={inputRef}
                data-testid={testid}
                type={visible ? "text" : "password"}
                value={value || ""}
                onChange={(event) => onChange(event.target.value)}
                className={inputClassName}
                placeholder={placeholder}
                autoComplete="new-password"
            />
            <button
                type="button"
                data-testid={`${testid}-toggle`}
                onClick={toggleVisibility}
                disabled={revealing}
                className="absolute inset-y-0 end-0 flex w-10 items-center justify-center text-muted-foreground hover:text-foreground"
                aria-label={visible ? "Nascondi credenziale" : "Mostra credenziale"}
                title={visible ? "Nascondi credenziale" : "Mostra credenziale"}
            >
                {visible ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
        </div>
    );
}
